import React from 'react';
import { Link } from 'react-router-dom';
import { MODULE_LABELS } from '../services/entitlements';

// Route→module map, mirrored from the module gates in App.tsx, so this page can
// offer "here's what your plan DOES include" links.
const MODULE_HOME: Record<string, string> = {
  mod_document_processing: '/documents',
  mod_tasks_compliance: '/tasks',
  mod_real_estate: '/real-estate',
  mod_insurance_licenses: '/insurances',
};

interface Props {
  /** The module the blocked route needs (e.g. mod_real_estate). */
  module: string;
  /** Modules the tenant actually has, for the "you do have" links. */
  available: string[];
}

const ModuleLocked: React.FC<Props> = ({ module, available }) => {
  const label = MODULE_LABELS[module] || 'This module';
  const have = available.filter((m) => MODULE_HOME[m]);

  return (
    <div style={{ padding: '40px', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        background: 'var(--card-background)', border: '1px solid var(--color-gray-200)', borderRadius: '20px',
        padding: '32px 28px', maxWidth: '520px', textAlign: 'center',
        fontFamily: "'Poppins', sans-serif",
      }}>
        <div style={{
          width: 48, height: 48, borderRadius: '50%', background: '#FEF3C7',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <h3 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 600, color: 'var(--color-gray-900)' }}>
          {label} isn’t in your plan
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: '13px', color: 'var(--color-gray-500)', lineHeight: 1.6 }}>
          Your workspace doesn’t currently include the <strong>{label}</strong> module.
          Ask your administrator to add it to your plan to unlock these pages.
        </p>

        {have.length > 0 && (
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--color-gray-400)', marginBottom: 10 }}>
              Your plan includes
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
              {have.map((m) => (
                <Link key={m} to={MODULE_HOME[m]}
                  style={{
                    fontSize: '13px', textDecoration: 'none', color: '#065F46',
                    background: '#ECFDF5', border: '1px solid #A7F3D0', borderRadius: 20,
                    padding: '6px 12px',
                  }}>
                  {MODULE_LABELS[m] || m} →
                </Link>
              ))}
            </div>
          </div>
        )}

        <div style={{ marginTop: 20 }}>
          <Link to="/dashboard" style={{ fontSize: '13px', color: 'var(--color-primary-text)', textDecoration: 'none' }}>
            ← Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ModuleLocked;
